<style lang="sass" scoped>
.top
  margin-bottom: 0px!important
  padding: 0px!important
  min-height: auto!important
  position: relative
  height: 100px
.certificate
  position: absolute
  top: 20px
  left: 60px
  span
    font-size: 24px
    font-weight: 600
  p
    color: #848a90
  .remain,.consume
    width: 500px
    float: left
.select
  position: relative
  .chooseType
    margin-right: 8px
    margin-top: 20px
    width: 150px
  .chooseDate
    position: absolute
    right: 5px
    margin-top: 20px
    width: 240px
  .el-icon-upload2
    position: absolute
    right: 255px
    margin-top: 30px
    cursor: pointer
.selectJob
  el-button
    // margin: 0 10px
    // font-size: 14px
    // font-weight: bold
    // cursor: pointer
    // color: cornflowerblue
.echarts
  margin-top: 40px
  width: 100%
  height: 350px
.detailData
  padding: 50px 0 10px
  i
    float: right
    cursor: pointer
.pagination
  margin-top: 30px
  text-align: right
</style>

<template lang="pug">
.wrapper
  headers(:navNum = "navNum", :username = "username")
  .layout-wrapper
    layout.top
      template(slot="page")
        img(src="../assets/background.svg" style="width:100%;height:100%")
        .certificate
          .remain
            span {{allRemain}}
            |&nbsp;&nbsp;条
            p 认证余量
          .consume
            span {{monthCount}}
            |&nbsp;&nbsp;条
            p 认证月耗
  .layout-wrapper
    layout
      template(slot="page")
        .tip.color-yellow
          i.el-icon-information &nbsp;认证数据因需要运营商二次审核，当日数据需要在次日 12 时之后查询。
        el-tabs(v-model="activeTab", @tab-click="changeTab" style="margin-top:20px")
          .select
            el-select.chooseType(v-model="params.appName" filterable remote :remote-method="searchApp" :loading="appLoading" placeholder="全部应用")
              el-option(v-for="item in appList", :label="item", :value="item", :key="item")
              .selectJob(style="text-align:center" v-if="appList && appList.length > 0")
                el-button(type="text" class="el-icon-arrow-left" @click.stop="prevePage" :disabled="selectPage <= appTotalPage")
                el-button(type="text" class="el-icon-arrow-right" @click.stop="nextPage" :disabled="selectPage >= appTotalPage")
            el-select.chooseType(v-model="params.platform", placeholder="请选择平台")
              el-option(v-for="item in platforms", :label="item.label", :value="item.value", :key="item.value")
            el-select.chooseType(v-model="params.isp", v-if="activeTab === 'detail'", placeholder="请选择运营商")
              el-option(v-for="item in isps", :label="item.label", :value="item.value", :key="item.value")
            el-select.chooseType(v-model="params.billingStatus", v-if="activeTab === 'detail'", placeholder="请选择计费状态")
              el-option(v-for="item in billingStatuss", :label="item.label", :value="item.value", :key="item.value")
            i.el-icon-upload2(@click="exportDetail()", v-show="activeTab === 'detail'")
            el-date-picker.chooseDate(v-model="date", type="daterange", align="right",
                          placeholder="选择日期范围", :picker-options="pickerOptions",
                          @change="handleDateChange")
          el-tab-pane(label="统计", name="statistic")
            .echarts(v-loading="statisticLoading")
              IEcharts(:option="line")
            .detailData
              |详细数据
              i.el-icon-upload2(@click="exportStatistic()")
            table.table(v-loading="statisticLoading")
              thead
                tr
                  th(width="15%") 日期
                  th(width="15%") 应用名
                  th(width="15%") 平台类型
                  th(width="20%") 一键登录请求次数
                  th(width="20%") 一键登录成功次数
              tbody
                tr.no-content(v-if="statisticList && statisticList.length <= 0")
                  td(colspan="7") 暂无数据
                tr(v-if="statisticList && statisticList.length > 0", v-for="item in statisticList")
                  td {{item.time}}
                  td {{item.appName}}
                  td {{item.platform}}
                  td {{item.allReqCount}}
                  td {{item.sucReqCount}}
          el-tab-pane(label="明细", name="detail")
            table.table(v-loading="detailLoading", style="margin-top:20px")
              thead
                tr
                  th 认证ID
                  th 平台
                  th 应用
                  th 运营商
                  th 登录手机号码
                  th 是否计费
                  th 认证时间
              tbody
                tr.no-content(v-if="detailList && detailList.length <= 0")
                  td(colspan="7") 暂无数据
                tr(v-if="detailList && detailList.length > 0", v-for="item in detailList")
                  td {{item.detail_id}}
                  td {{item.platform}}
                  td {{item.appName}}
                  td {{item.isp === 'CTN' ? '电信' : item.isp === 'CUN' ? '联通' : '移动'}}
                  td {{item.phone}}
                  td {{item.billingStatus === 'success' ? '是' : '否'}}
                  td {{item.create_time}}
            el-pagination.pagination(
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="20"
              layout="total, prev, pager, next, jumper"
              :total="pageTotal")
</template>

<script>
import headers from '../components/headers'
import layout from '../components/layout'
// import RemoteSelect from '../components/remoteSelect'
import IEcharts from 'vue-echarts-v3/src/full.js'
import moment from 'moment'
import { mapState } from 'vuex'
import { stringify } from 'query-string';

export default {
  components: { headers, layout, IEcharts },
  data () {
    return {
      appLoading: false,
      selectPage: 1,
      activeTab: 'statistic',
      navNum: 5,
      date: [moment().subtract(7, 'days').format('YYYY-MM-DD 00:00:00'), moment().subtract(1, 'days').format('YYYY-MM-DD 23:59:59')],
      currentPage: 1,
      params: {
        from: 0,
        size: 20,
        start_time: '',
        end_time: ''
      },
      platforms: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 'ANDROID',
          label: 'Android'
        },
        {
          value: 'IOS',
          label: 'iOS'
        }
      ],
      isps: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 'CMN',
          label: '移动'
        },
        {
          value: 'CUN',
          label: '联通'
        },
        {
          value: 'CTN',
          label: '电信'
        }
      ],
      billingStatuss: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 'success',
          label: '计费'
        },
        {
          value: 'fail',
          label: '不计费'
        }
      ],
      timeOptionRange: null,
      pickerOptions: {
        onPick (maxDate, minDate) {
          // 当选中了第一个日期还没选第二个
          // 只选中一个的时候自动赋值给minDate，当选中第二个后组件自动匹配，将大小日期分别赋值给maxDate、minDate
          if (maxDate.minDate && !maxDate.maxDate) {
            this.timeOptionRange = maxDate.minDate;
          }
          // 如果有maxDate属性，表示2个日期都选择了，则重置timeOptionRange
          if (maxDate.maxDate) {
            this.timeOptionRange = null;
          }
          console.log(maxDate.minDate, maxDate.maxDate)
        },
        disabledDate (time) {
          // 获取选中时间
          // let timeOptionRange = this.timeOptionRange;
          // // 获取时间范围(30天的毫秒数)
          // let secondNum = 30 * 24 * 60 * 60 * 1000;
          // if (timeOptionRange) {
          //   // 如果有选中时间 设置超过 选中时间后的30天||超过选中前的30天||大于等于当前时间 不可选
          //   return time.getTime() > timeOptionRange.getTime() + secondNum || time.getTime() < timeOptionRange.getTime() - secondNum || time.getTime() > (Date.now() - 3600 * 1000 * 24 * 1);
          // } else {
          //   // 如果没有选中时间（初始化状态） 设置当前时间及以后的时间不可选
            // return time.getTime() > Date.now() - 3600 * 1000 * 24 * 1 || time.getTime() < Date.now() - 2.592e9;
          // }
          return time.getTime() > Date.now() - 3600 * 1000 * 24 * 1 || time.getTime() < Date.now() - 2.592e9;
        },
        shortcuts: [
          {
            text: '昨天',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近 7 天',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近 30 天',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      allRemain: state => state.statistic.allRemain,
      monthCount: state => state.statistic.monthCount,
      appList: state => state.statistic.appList,
      appTotalPage: state => state.statistic.appTotalPage,
      chartDate: state => state.statistic.chartDate,
      reqCount: state => state.statistic.reqCount,
      loginCount: state => state.statistic.loginCount,
      statisticList: state => state.statistic.statisticList,
      detailList: state => state.statistic.detailList,
      pageTotal: state => state.statistic.pageTotal,
      statisticLoading: state => state.statistic.statisticLoading,
      detailLoading: state => state.statistic.detailLoading,
      username: state => state.dashboard.username
    }),
    line: function () {
      return {
        color: ['#00b7ee', '#f0adad'],
        title: {
          text: '消耗统计',
          left: '2%'
        },
        legend: {
          data: ['一键登录请求次数', '一键登录成功次数'],
          selectedMode: false,
          right: '2%'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '0',
          right: '5px',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.chartDate
        },
        yAxis: {
          type: 'value',
          min: 0,
          splitNumber: 4,
          minInterval: 1
        },
        series: [{
          name: '一键登录请求次数',
          type: 'line',
          data: this.reqCount
        }, {
          name: '一键登录成功次数',
          type: 'line',
          data: this.loginCount
        }]
      };
    }
  },
  watch: {
    params: {
      handler: function (newValue, oldValue) {
        this.getStatistics();
      },
      deep: true
    }
  },
  mounted () {
    this.getOverview();
    this.getAppList();
    this.params.start_time = (new Date(this.date[0])).getTime() / 1000
    this.params.end_time = (new Date(this.date[1])).getTime() / 1000
    this.getStatistics();
  },
  methods: {
    async getOverview () {
      await this.$store.dispatch('getOverview', {});
    },
    async getAppList () {
      const params = {
        from: (this.selectPage - 1) * 20,
        size: (this.selectPage - 1) * 20 + 20
      }
      await this.$store.dispatch('getAppList', params);
    },
    searchApp (query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.$store.dispatch('getAppList', {appName: query});
        }, 200);
      } else {
        this.getAppList();
      }
    },
    changeTab (tab) {
      this.params = {
        from: 0,
        size: 20,
        start_time: '',
        end_time: ''
      };
      this.params.start_time = (new Date(this.date[0])).getTime() / 1000
      this.params.end_time = (new Date(this.date[1])).getTime() / 1000
      if (tab.name === 'statistic') {
        this.date = [moment().subtract(7, 'days').format('YYYY-MM-DD 00:00:00'), moment().subtract(1, 'days').format('YYYY-MM-DD 23:59:59')]
        this.getStatistics();
      }
      if (tab.name === 'detail') {
        this.date = [moment().subtract(1, 'days').format('YYYY-MM-DD 00:00:00'), moment().subtract(1, 'days').format('YYYY-MM-DD 23:59:59')]
        this.getDetails();
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.params.from = (val - 1) * 20
      this.params.size = (val - 1) * 20 + 20
      this.getDetails();
    },
    handleDateChange (val) {
      if (val === '') {
        return;
      }
      const splitDate = val.split(' - ');
      this.params.start_time = (new Date(splitDate[0] + ' 00:00:00')).getTime() / 1000 || '';
      this.params.end_time = (new Date(splitDate[1] + ' 23:59:59')).getTime() / 1000 || '';
      if (this.activeTab === 'statistic') {
        this.getStatistics();
      } else {
        this.getDetails();
      }
    },
    async getStatistics () {
      delete this.params.from
      delete this.params.size
      if (this.params.appName === '全部应用') this.params.appName = ''
      await this.$store.dispatch('getStatistics', this.params);
    },
    async getDetails () {
      if (this.params.appName === '全部应用') this.params.appName = ''
      await this.$store.dispatch('getDetails', this.params);
    },
    prevePage () {
      --this.selectPage;
      if (this.selectPage < 1) { // 判断点击的页数是否小于1
        this.selectPage = 1;
      };
      this.getAppList();
    },
    nextPage () {
      if (this.selectPage < this.appTotalPage) { // 判断点击的页数是否小于总页数;
        ++this.selectPage;
        this.getAppList();
      }
    },
    exportStatistic () {
      delete this.params.from
      delete this.params.size
      window.location.href = `https://sim-api.upyun.com/statistics/download?${stringify(this.params)}`;
    },
    exportDetail () {
      window.location.href = `https://sim-api.upyun.com/statistics/detail/download?${stringify(this.params)}`;
    }
  }
}
</script>



// WEBPACK FOOTER //
// statistic.vue?2cba909e